import React, {useState} from 'react'
// import { useLocation } from 'react-router-dom';
import { CopyToClipboard } from "react-copy-to-clipboard";
import Header from '../common/Header'

function Referral() {
    // let location = useLocation();
	const queryParams = new URLSearchParams(window.location.search);
    const currency = queryParams.get("currency");
    const [address, setAddress] = useState("");
    const [referralLink, setReferralLink] = useState({
        value: "",
        isLoaded: false
    });

    const linkGenerator = () =>{
        setReferralLink({
            value: `${window.location.origin}/?currency=${currency}&referrer=${address}`,
            isLoaded: true 
        })
    }
	return (
		<>
			<Header />
			<section className="section2" id="" data-section="section1">
				<div className="container">
					<div className='mainBox'>
					<div className='caption'>
					<div className='btm-form' style={{padding: "50px 15px"}}>
						<h3 className='mainBox bulksender-head'>MultiTokendrop Referral Program</h3>
						<div className='iconList' >
							<div className='imgWithctn'>
								<img src="images/3359235.png" alt="" />
								<p>Put your address</p>
							</div>
							<div className='centerArrow'>
								<img src="images/next.png" alt=""/>
							</div>
							<div className='imgWithctn'>
								<img src="images/3359235.png" alt=""/>
								<p>Generate link</p>
							</div>
							<div className='centerArrow'>
								<img src="images/next.png" alt=""/>
							</div>
							<div className='imgWithctn'>
								<img src="images/3359235.png" alt=""/>
								<p>Share your link</p>
							</div>
							<div className='centerArrow'>
								<img src="images/next.png" alt=""/>
							</div>
							<div className='imgWithctn'>
								<img src="images/3359235.png" alt=""/>
								<p>Airdrop done by your referral</p>
							</div>
							<div className='centerArrow'>
								<img src="images/next.png" alt=""/>
							</div>
							<div className='imgWithctn'>
								<img src="images/3359235.png" alt=""/>
								<p>Earn real-time referral rewards</p>
							</div>
						</div>
						<p className='afterList'>You will earn 0.01 ETH from any airdrop done by your referral.</p>
						<div className='inputBoxhere'>
							<p>Put your valid wallet address</p>
							<div className='inputBox btt-input'>
								<input className="referral-link mobile-inn" type="text" value={address} onChange={(events)=>{setAddress(events.target.value)}}/>
								<button className='mobile-gen' type="button " onClick = {linkGenerator}>Generate</button>
							</div>
						</div>
                       {referralLink.isLoaded && <div className='inputBoxhere'>
							<p>Generated referral link</p>
							<div className='inputBox'>
								<input className="referral-link  mobile-inn " type="text" value={referralLink.value}/>
                                <CopyToClipboard text={referralLink.value}>
                                    <div className="copy-area">
                                        <button className='mobile-gen' type="button">Copy</button>
                     </div>
                                </CopyToClipboard>
								
							</div>
						</div>}
					</div>
					</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default Referral